module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ed2e8ddf3110ae01c46533a8cfebb5d9.png";